export default "__VITE_ASSET__CBmuaLS5__"